export default "__VITE_ASSET__CJaTEvC0__"